import React from 'react';
import SidebarCard from './SidebarCard';

/* 21-day ad impression sparkline; only rendered when the page carries stats. */
export default function AdStatsCard({ page, open, onToggle }) {
  const dailyMap = page.ad_impressions_daily;
  if (!dailyMap) return null;

  const clicksMap = page.ad_clicks_daily || {};
  const today = new Date();
  const series = [];
  const clickSeries = [];
  const labels = [];
  for (let i = 20; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    const key = d.toISOString().slice(0, 10);
    series.push(dailyMap[key] || 0);
    clickSeries.push(clicksMap[key] || 0);
    labels.push(key.slice(5));
  }
  const maxVal = Math.max(...series, 1);
  const todayImpr = series[series.length - 1];
  const todayClicks = clickSeries[clickSeries.length - 1];

  return (
    <SidebarCard id="adstats" title="Ad impressions" open={open} onToggle={onToggle}>
      <div style={{ display: 'flex', gap: 12, fontSize: 13, flexWrap: 'wrap', marginBottom: 8 }}>
        <span><strong>{(page.ad_impressions_total || 0).toLocaleString()}</strong> 21d</span>
        <span><strong>{todayImpr.toLocaleString()}</strong> today</span>
        <span style={{ color: 'var(--color-muted)' }}>{(page.ad_clicks_total || 0).toLocaleString()} clicks ({todayClicks} today)</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', height: 48, gap: 1 }} role="img" aria-label={`Daily ad impressions for the last 21 days, peaking at ${maxVal}`}>
        {series.map((v, i) => (
          <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div
              style={{
                width: '100%',
                height: `${Math.max((v / maxVal) * 44, v > 0 ? 2 : 0)}px`,
                backgroundColor: i === series.length - 1 ? 'var(--color-primary)' : '#adb5bd',
                borderRadius: '2px 2px 0 0',
              }}
              title={`${labels[i]}: ${v} impressions`}
            />
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', fontSize: 9, color: 'var(--color-muted)', marginTop: 2 }}>
        {labels.map((l, i) => (
          <div key={i} style={{ flex: 1, textAlign: 'center' }}>{i % 7 === 0 ? l : ''}</div>
        ))}
      </div>
      {page.ad_stats_updated_at && (
        <div style={{ fontSize: 11, color: 'var(--color-muted)', marginTop: 6 }}>
          Updated {new Date(page.ad_stats_updated_at).toLocaleString()}
        </div>
      )}
    </SidebarCard>
  );
}
